"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CBAGrid = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var collectionsRef_1 = require("common/db/collectionsRef");
var budgetLinesList_1 = require("common/global/budgetLinesList");
var currenciesList_1 = require("common/global/currenciesList");
var donorsList_1 = require("common/global/donorsList");
var officesList_1 = require("common/global/officesList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var usersList_1 = require("common/global/usersList");
var lodash_1 = require("lodash");
var emptyCell_1 = require("portal/components/Grid/helpers/emptyCell");
var valueCell_1 = require("portal/components/Grid/helpers/valueCell");
var header_1 = require("portal/components/header");
var getDateForCell_1 = __importDefault(require("portal/utils/getDateForCell"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Grid_1 = require("../../../components/Grid/Grid");
var titleCell_1 = require("../../../components/Grid/helpers/titleCell");
var valueByMode_1 = require("../../../components/Grid/helpers/valueByMode");
var OrderHeader_1 = __importDefault(require("../components/OrderHeader"));
var IRGrid_1 = require("../IR/IRGrid");
var permissiontypes_1 = require("portal/pages/Tables/Users/permissiontypes");
var CBAGrid = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    var state = _a.state, dispatch = _a.dispatch, mode = _a.mode, CBAId = _a.CBAId;
    // const hasSignature = globalProjectsData[state.projectId].hasSignature ?? false
    var hasSignature = false;
    var t = (0, react_i18next_1.useTranslation)().t;
    //   const projectCode = globalProjectsData[state.projectId]?.code;
    var projectsCodes = state.projectsIds
        .map(function (projectId) { var _a; return (_a = projectsList_1.globalProjectsData[projectId !== null && projectId !== void 0 ? projectId : ""]) === null || _a === void 0 ? void 0 : _a.code; })
        .join(", ");
    //   const budgetLineCode = globalBudgetLinesData[state.budgetLineId]?.code;
    var suppliersTitlesCells = (_b = state.RFQsData) === null || _b === void 0 ? void 0 : _b.map(function (_, idx) {
        return (0, titleCell_1.TitleCell)({
            title: "".concat(t("cba.nameofsupplier"), " ").concat(idx + 1),
            colSpan: 7,
            rowSpan: 1,
        });
    });
    var suppliersNamesCells = (_c = state === null || state === void 0 ? void 0 : state.RFQsData) === null || _c === void 0 ? void 0 : _c.map(function (RFQDoc) {
        var _a;
        return (0, valueByMode_1.ValueByMode)({
            mode: mode,
            value: (_a = RFQDoc === null || RFQDoc === void 0 ? void 0 : RFQDoc.supplierName) !== null && _a !== void 0 ? _a : "",
            inputType: "text",
            path: "ref",
            colSpan: 7,
        });
    });
    var currencyExchangeRatesCells = (0, lodash_1.flatMap)((_d = state.RFQsData) !== null && _d !== void 0 ? _d : [], function (RFQDoc, idx) {
        var _a, _b, _c;
        var currencyName = (_a = currenciesList_1.globalCurrenciesData[RFQDoc.currencyId]) === null || _a === void 0 ? void 0 : _a.name;
        return [
            // TitleCell({ title: t('cba.currency'), colSpan: 1 }),
            // ValueByMode({ mode, value: currencyName ?? '', inputType: 'text', colSpan: 2 }),
            (0, titleCell_1.TitleCell)({ title: t("cba.exchangeRate"), colSpan: 3 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_c = ((_b = state.currenciesExchangeRates) !== null && _b !== void 0 ? _b : [])[idx]) !== null && _c !== void 0 ? _c : "",
                inputType: "numberInput",
                path: "currenciesExchangeRates[".concat(idx, "]"),
                colSpan: 4,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ];
    });
    var currencies = (0, lodash_1.flatMap)((_e = state.RFQsData) !== null && _e !== void 0 ? _e : [], function (RFQDoc, idx) {
        var _a;
        var currencyName = (_a = currenciesList_1.globalCurrenciesData[RFQDoc.currencyId]) === null || _a === void 0 ? void 0 : _a.name;
        return [
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: currencyName !== null && currencyName !== void 0 ? currencyName : "",
                inputType: "text",
                colSpan: 7,
            }),
        ];
    });
    var suppliersColumns = (_f = state.RFQsData) === null || _f === void 0 ? void 0 : _f.map(function (RFQDoc) {
        var filtered = (0, lodash_1.pickBy)(state.CBARFQItems, function (d) { return d.supplierId == RFQDoc.supplierId; });
        var CBARFQItemsGrid = (0, lodash_1.map)((0, lodash_1.sortBy)(filtered, function (x) { return x === null || x === void 0 ? void 0 : x.index; }), function (item) {
            var _a;
            var offeredItem = item.offeredItem, unitPrice = item.unitPrice, totalPrice = item.totalPrice, technicalEvaluationMark = item.technicalEvaluationMark, warranty = item.warranty, expiryDate = item.expiryDate, originCountry = item.originCountry;
            return [
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: offeredItem !== null && offeredItem !== void 0 ? offeredItem : "",
                    inputType: "text",
                    colSpan: 1,
                }),
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: originCountry !== null && originCountry !== void 0 ? originCountry : "-",
                    inputType: "text",
                    colSpan: 1,
                }),
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: warranty !== null && warranty !== void 0 ? warranty : "-",
                    inputType: "text",
                    colSpan: 1,
                }),
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: expiryDate !== null && expiryDate !== void 0 ? expiryDate : "-",
                    inputType: "text",
                    colSpan: 1,
                }),
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: unitPrice !== null && unitPrice !== void 0 ? unitPrice : "",
                    inputType: "text",
                    colSpan: 1,
                }),
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: (_a = totalPrice.toFixed(2)) !== null && _a !== void 0 ? _a : "",
                    inputType: "text",
                    colSpan: 1,
                }),
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: technicalEvaluationMark !== null && technicalEvaluationMark !== void 0 ? technicalEvaluationMark : "",
                    inputType: "numberInput",
                    path: "CBARFQItems[".concat(item.id, "].technicalEvaluationMark"),
                    colSpan: 1,
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                }),
            ];
        });
        return CBARFQItemsGrid;
    });
    var donorId = (_g = projectsList_1.globalProjectsData[state.projectId]) === null || _g === void 0 ? void 0 : _g.donorId;
    var miLogo = __assign(__assign({}, header_1.baseCell), { type: "image", src: (_h = donorsList_1.globalDonorsData[donorId]) === null || _h === void 0 ? void 0 : _h.logo, height: 50, colSpan: 4, textAlign: "center" });
    var CBAHeader = [
        (0, IRGrid_1.logoHeader)({
            projectId: state.projectId,
            idaLogo: miLogo,
            title: t("cba.comparativeBidAnalysisCBA"),
            colSpan: 20,
        }),
        [
            (0, titleCell_1.TitleCell)({ title: t("cba.cbaNo"), colSpan: 4 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_j = state.ref) !== null && _j !== void 0 ? _j : "",
                inputType: "text",
                path: "ref",
                colSpan: 3,
            }),
            (0, titleCell_1.TitleCell)({ title: t("cba.cbaDate"), colSpan: 3 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? t("common.date", { date: (0, getDateForCell_1.default)(state === null || state === void 0 ? void 0 : state.CBADate, mode) })
                    : (0, getDateForCell_1.default)(state === null || state === void 0 ? void 0 : state.CBADate, mode),
                inputType: "datePicker",
                path: "CBADate",
                colSpan: 4,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
            (0, titleCell_1.TitleCell)({ title: t("cba.projectCode"), colSpan: 3 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: projectsCodes !== null && projectsCodes !== void 0 ? projectsCodes : "",
                inputType: "text",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: t("cba.office"), colSpan: 3 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_m = officesList_1.globalOfficesData[(_l = (_k = state.IRData) === null || _k === void 0 ? void 0 : _k.officeId) !== null && _l !== void 0 ? _l : ""].name) !== null && _m !== void 0 ? _m : "",
                inputType: "text",
                colSpan: 4,
            }), //TODO: add office
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("cba.irNo"), colSpan: 4 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_o = state.IRref) !== null && _o !== void 0 ? _o : "",
                inputType: "text",
                colSpan: 3,
            }),
            // TitleCell({ title: t('cba.budgetLine'), colSpan: 2 }),
            // ValueByMode({ mode, value: budgetLineCode ?? '', inputType: 'text', colSpan: 3 }),
        ],
        __spreadArray(__spreadArray([
            (0, titleCell_1.TitleCell)({ title: "", colSpan: 6, rowSpan: 3 })
        ], suppliersTitlesCells, true), [
            (0, titleCell_1.TitleCell)({
                title: t("cba.selectedSupplierNumber"),
                colSpan: 1,
                rowSpan: 4,
            }),
        ], false),
        __spreadArray([], suppliersNamesCells, true),
        __spreadArray([], currencyExchangeRatesCells, true),
    ];
    var itemsHeader = __spreadArray([
        (0, titleCell_1.TitleCell)({ title: t("cba.itemNo") }),
        (0, titleCell_1.TitleCell)({ title: t("cba.budgetLineId") }),
        (0, titleCell_1.TitleCell)({ title: t("cba.itemDescription"), colSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("cba.unit") }),
        (0, titleCell_1.TitleCell)({ title: t("cba.quantity") })
    ], (0, lodash_1.flatMap)(suppliersColumns !== null && suppliersColumns !== void 0 ? suppliersColumns : [], function () { return [
        (0, titleCell_1.TitleCell)({ title: t("rfq.brand") }),
        (0, titleCell_1.TitleCell)({ title: t("rfq.originCountry") }),
        (0, titleCell_1.TitleCell)({ title: t("rfq.warranty") }),
        (0, titleCell_1.TitleCell)({ title: t("rfq.expiryDate") }),
        (0, titleCell_1.TitleCell)({ title: t("cba.unitPrice") }),
        (0, titleCell_1.TitleCell)({ title: t("cba.totalPrice") }),
        (0, titleCell_1.TitleCell)({ title: t("cba.technicalEvolutionMark") }),
    ]; }), true);
    var itemsBody = (0, lodash_1.map)((0, lodash_1.sortBy)((_p = state.CBAItems) !== null && _p !== void 0 ? _p : [], function (x) { return x.index; }), function (CBAItemDoc, idx) {
        var _a, _b, _c;
        var originalIndex = state.CBAItems.findIndex(function (x) { return x === CBAItemDoc; });
        var productName = CBAItemDoc.productName, unitId = CBAItemDoc.unitId, quantity = CBAItemDoc.quantity, productDescription = CBAItemDoc.productDescription, budgetLineId = CBAItemDoc.budgetLineId;
        var unitName = (_a = unitsList_1.globalUnitsData[unitId]) === null || _a === void 0 ? void 0 : _a.name;
        var budgetLine = budgetLineId !== null && budgetLineId !== void 0 ? budgetLineId : state.budgetLineId;
        var budgetLinesIds = CBAItemDoc.budgetLinesIds;
        var selectOptions = state.RFQsData.map(function (d, index) { return ({
            text: index + 1,
            value: index + 1,
        }); });
        return __spreadArray(__spreadArray([
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: idx + 1, inputType: "text", colSpan: 1 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                //   value:  globalBudgetLinesData[budgetLine ?? ""].code ?? "",
                value: budgetLinesIds
                    .map(function (budgetLineId) { var _a; return (_a = budgetLinesList_1.globalBudgetLinesData[budgetLineId !== null && budgetLineId !== void 0 ? budgetLineId : ""]) === null || _a === void 0 ? void 0 : _a.code; })
                    .join(", "),
                inputType: "text",
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_b = "".concat(productName, "/").concat(productDescription)) !== null && _b !== void 0 ? _b : "",
                inputType: "text",
                colSpan: 2,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: unitName !== null && unitName !== void 0 ? unitName : "",
                inputType: "text",
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: quantity !== null && quantity !== void 0 ? quantity : "",
                inputType: "text",
                colSpan: 1,
            })
        ], (0, lodash_1.flatMap)(suppliersColumns, function (suppliers) { return suppliers[idx]; }), true), [
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_c = state.CBAItems[originalIndex]) === null || _c === void 0 ? void 0 : _c.supplierSelectionNumber,
                inputType: "select",
                path: "CBAItems[".concat(originalIndex, "].supplierSelectionNumber"),
                colSpan: 1,
                selectData: selectOptions,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ], false);
    });
    var itemsSummary = [];
    var bidDetails = [
        __spreadArray([
            (0, titleCell_1.TitleCell)({ title: t("cba.bidDetails"), colSpan: 6 })
        ], (_q = state.RFQsData) === null || _q === void 0 ? void 0 : _q.map(function (RFQDoc) {
            return (0, titleCell_1.TitleCell)({ title: RFQDoc === null || RFQDoc === void 0 ? void 0 : RFQDoc.supplierName, colSpan: 7 });
        }), true),
        __spreadArray(__spreadArray([
            (0, titleCell_1.TitleCell)({ title: t("cba.total"), colSpan: 6 })
        ], (_r = state.currenciesIds) === null || _r === void 0 ? void 0 : _r.map(function (_, idx) {
            return (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (state.RFQsTotals[idx] * state.currenciesExchangeRates[idx]).toFixed(2),
                inputType: "text",
                colSpan: 7,
            });
        }), true), [
            (0, emptyCell_1.emptyCell)({ rowSpan: 7 }),
        ], false),
        __spreadArray([
            (0, titleCell_1.TitleCell)({ title: "VAT", colSpan: 6 })
        ], (_s = state.currenciesIds) === null || _s === void 0 ? void 0 : _s.map(function (_, idx) {
            return (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.RFQsTaxes[idx] !== "" && state.RFQsTaxes[idx] !== "included"
                    ? state.RFQsTaxes[idx] * state.currenciesExchangeRates[idx]
                    : state.RFQsTaxes[idx],
                inputType: "text",
                colSpan: 7,
            });
        }), true),
        __spreadArray([
            (0, titleCell_1.TitleCell)({ title: t("cba.shippingCostInsurance"), colSpan: 6 })
        ], (_t = state.currenciesIds) === null || _t === void 0 ? void 0 : _t.map(function (_, idx) {
            return (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.RFQsShippingCosts[idx] !== "" &&
                    state.RFQsShippingCosts[idx] !== "included"
                    ? state.RFQsShippingCosts[idx] *
                        state.currenciesExchangeRates[idx]
                    : state.RFQsShippingCosts[idx],
                inputType: "text",
                colSpan: 7,
            });
        }), true),
        __spreadArray([
            (0, titleCell_1.TitleCell)({ title: t("cba.overallTotal"), colSpan: 6 })
        ], (_u = state.currenciesIds) === null || _u === void 0 ? void 0 : _u.map(function (_, idx) {
            return (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (state.RFQsOverallTotals[idx] * state.currenciesExchangeRates[idx]).toFixed(2),
                inputType: "text",
                colSpan: 7,
            });
        }), true),
        __spreadArray([(0, titleCell_1.TitleCell)({ title: "Currency", colSpan: 6 }), ,], currencies, true),
        __spreadArray([
            (0, titleCell_1.TitleCell)({ title: "Quotation Validity", colSpan: 6 })
        ], (_v = state.RFQsData) === null || _v === void 0 ? void 0 : _v.map(function (item) {
            var _a;
            return (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_a = item.quotationValidity) !== null && _a !== void 0 ? _a : "",
                inputType: "text",
                colSpan: 7,
            });
        }), true),
        __spreadArray([
            (0, titleCell_1.TitleCell)({ title: "Delivery Location", colSpan: 6 })
        ], (_w = state.RFQsData) === null || _w === void 0 ? void 0 : _w.map(function (item) {
            var _a;
            return (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_a = item.deliveryPlace) !== null && _a !== void 0 ? _a : "",
                inputType: "text",
                colSpan: 7,
            });
        }), true),
        __spreadArray([
            (0, titleCell_1.TitleCell)({ title: "Delivery Schedule", colSpan: 6 })
        ], (_x = state.RFQsData) === null || _x === void 0 ? void 0 : _x.map(function (item) {
            var _a;
            return (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_a = item.deliveryDate) !== null && _a !== void 0 ? _a : "",
                inputType: "text",
                colSpan: 7,
            });
        }), true),
        __spreadArray([
            (0, titleCell_1.TitleCell)({ title: "Payment Terms", colSpan: 6 })
        ], (_y = state.RFQsData) === null || _y === void 0 ? void 0 : _y.map(function (item) {
            var _a;
            return (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_a = item.deliveryTerms) !== null && _a !== void 0 ? _a : "",
                inputType: "text",
                colSpan: 7,
            });
        }), true),
        __spreadArray([
            (0, titleCell_1.TitleCell)({ title: "Payment Preferences", colSpan: 6 })
        ], (_z = state.RFQsData) === null || _z === void 0 ? void 0 : _z.map(function (item) {
            return (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.byBank == "yes"
                    ? "by bank"
                    : item.byCash == "yes"
                        ? "by cash"
                        : "-",
                inputType: "text",
                colSpan: 7,
            });
        }), true),
    ];
    var preparedByLogistics = [
        [
            (0, titleCell_1.TitleCell)({
                title: t("cba.preparedByLogistics"),
                colSpan: 2,
                rowSpan: 2,
            }),
            (0, titleCell_1.TitleCell)({ title: "Name/Tittle", colSpan: 8 }),
            (0, titleCell_1.TitleCell)({ title: "Signature", colSpan: 7 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "",
                colSpan: 4,
                rowSpan: 2 + 18,
                path: "",
            }),
        ],
        [
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.preparedByLogistics,
                inputType: "textInput",
                colSpan: 8,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
                path: "preparedByLogistics",
            }),
            (0, valueCell_1.ValueCell)({
                value: " ",
                img: hasSignature &&
                    ((_1 = (_0 = usersList_1.globalUsersData[state.requestedBy]) === null || _0 === void 0 ? void 0 : _0.signatureURL) !== null && _1 !== void 0 ? _1 : ""),
                colSpan: 7,
                rowSpan: 1,
            }),
        ],
    ];
    var approvalCell = function (approvalType, requiredApprovalType) {
        var _a, _b, _c;
        var projectId = state.projectId;
        var selectedSuppliers = (0, lodash_1.uniq)((_a = state.CBAItems) === null || _a === void 0 ? void 0 : _a.map(function (x) {
            var _a, _b, _c;
            var supplier = (_c = (_b = (_a = state.suppliersData) === null || _a === void 0 ? void 0 : _a.find(function (e) { return (x === null || x === void 0 ? void 0 : x.selectedSupplierId) === e.id; })) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "";
            return supplier;
        }));
        var total = (0, lodash_1.flatMap)(selectedSuppliers.map(function (supplierId) {
            return state.RFQsData.filter(function (RFQItem) {
                return supplierId === RFQItem.supplierId;
            });
        }));
        var max = (0, lodash_1.maxBy)(total, function (x) { return x.overallTotal; });
        var exchangeRate = (max === null || max === void 0 ? void 0 : max.exchangeRate) === 0 ? 1 : max === null || max === void 0 ? void 0 : max.exchangeRate;
        var totalInProjectCurrency = (max === null || max === void 0 ? void 0 : max.overallTotal) / exchangeRate;
        // const approvalPermissions = hasProjectPermissionWithMinAndMax(
        //   projectId,
        //   [`CBA${approvalType}Approval`],
        //   totalInProjectCurrency
        // );
        var approvalPermissions = true;
        var approval = (_b = state.approvalsData) === null || _b === void 0 ? void 0 : _b.find(function (e) {
            return e.approvalType === approvalType;
        });
        var requiredApproval = (_c = state.approvalsData) === null || _c === void 0 ? void 0 : _c.find(function (e) {
            return e.approvalType === requiredApprovalType;
        });
        console.log({ approvalPermissions: approvalPermissions });
        if (approval) {
            return (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: "",
                colSpan: 2,
                rowSpan: 2,
            });
        }
        else if ((approvalPermissions &&
            requiredApproval &&
            state.status !== "approved" &&
            state.status !== "cancelled" &&
            state.status !== "completed" &&
            state.status !== "draft" &&
            state.status !== "singedAndArchived") ||
            (approvalPermissions &&
                !requiredApprovalType &&
                state.status !== "approved" &&
                state.status !== "cancelled" &&
                state.status !== "completed" &&
                state.status !== "draft" &&
                state.status !== "singedAndArchived")) {
            return {
                action: "Approve",
                // payload: approvalType,
                payload: {
                    approvedAt: state.approvedAtSignatureDate.toDate(),
                    approvalType: approvalType,
                },
                text: t("cba.approve"),
                confirmMessage: t("alerts.areYouSureYouWantToApproveThisDocument"),
                confirmAction: true,
                type: "button",
                colSpan: 2,
                rowSpan: 2,
            };
        }
        else {
            return (0, emptyCell_1.emptyCell)({
                colSpan: 2,
                rowSpan: 2,
            });
        }
        // return [
        //     ValueByMode({
        //         mode,
        //         value:
        //             mode === 'view'
        //                 ? t('common.date', { date: getDateForCell(approval?.approvedAt, mode) })
        //                 : getDateForCell(approval?.approvedAt, mode),
        //         inputType: 'text',
        //         colSpan: 2,
        //         rowSpan: 2,
        //     }),
        //     ApprovalCell,
        // ]
    };
    function approvals(state, t) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var getApproval = function (approvalType) {
            var _a;
            var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
                return e.approvalType === approvalType;
            });
            return approval;
        };
        var approvingDate = function (approvalType) {
            var approval2 = getApproval(approvalType);
            var date = approval2 === null || approval2 === void 0 ? void 0 : approval2.approvedAt;
            return t("common.date", { date: date === null || date === void 0 ? void 0 : date.toDate() });
        };
        var approvingSig = function (approvalType) {
            var approval2 = getApproval(approvalType);
            var sig = approval2 === null || approval2 === void 0 ? void 0 : approval2.signatureURL;
            return sig;
        };
        var sigMode = function (type) {
            var _a;
            var approval = (_a = state === null || state === void 0 ? void 0 : state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (approval) { return approval.approvalType == type; });
            var newMode = mode == "edit" ? "view" : approval ? "view" : "edit";
            return newMode;
        };
        return [
            [
                (0, titleCell_1.TitleCell)({ title: t("cba.selectedSupplierNo"), colSpan: 4 }),
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: (0, lodash_1.uniq)((_a = state.CBAItems) === null || _a === void 0 ? void 0 : _a.map(function (x) {
                        var _a, _b, _c;
                        var supplier = (_c = (_b = (_a = state.suppliersData) === null || _a === void 0 ? void 0 : _a.find(function (e) { return (x === null || x === void 0 ? void 0 : x.selectedSupplierId) === e.id; })) === null || _b === void 0 ? void 0 : _b.companyName) !== null && _c !== void 0 ? _c : "";
                        return "".concat(x.supplierSelectionNumber, "-").concat(supplier);
                    })).join(", "),
                    inputType: "text",
                    colSpan: 9,
                }),
                (0, valueByMode_1.ValueByMode)({
                    mode: "view",
                    value: "",
                    inputType: "textArea",
                    path: "",
                    colSpan: 14,
                    rowSpan: 5,
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                }),
            ],
            [
                (0, titleCell_1.TitleCell)({ title: "Criteria Selection", colSpan: 4, rowSpan: 3 }),
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: "Price",
                    inputType: "text",
                    colSpan: 2,
                }),
                (0, titleCell_1.TitleCell)({ title: "Prepared By", colSpan: 3 }),
                (0, valueByMode_1.ValueByMode)({
                    mode: "view",
                    value: (_c = (_b = usersList_1.globalUsersData[state.requestedBy]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "",
                    inputType: "textInput",
                    colSpan: 4,
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                }),
            ],
            [
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: "Quality",
                    inputType: "text",
                    colSpan: 2,
                }),
                (0, titleCell_1.TitleCell)({ title: "Title", colSpan: 3 }),
                (0, valueByMode_1.ValueByMode)({
                    mode: "view",
                    value: (_e = (_d = usersList_1.globalUsersData[state.requestedBy]) === null || _d === void 0 ? void 0 : _d.jobTitle) !== null && _e !== void 0 ? _e : "",
                    inputType: "textInput",
                    colSpan: 4,
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                }),
            ],
            [
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: "Availability",
                    inputType: "text",
                    colSpan: 2,
                }),
                (0, titleCell_1.TitleCell)({ title: "Signature", colSpan: 3 }),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature &&
                        ((_g = (_f = usersList_1.globalUsersData[state.requestedBy]) === null || _f === void 0 ? void 0 : _f.signatureURL) !== null && _g !== void 0 ? _g : ""),
                    colSpan: 4,
                    rowSpan: 1,
                }),
            ],
            [(0, titleCell_1.TitleCell)({ title: t("cba.justificationForSelection"), colSpan: 13 })],
            [
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: (_h = state.justificationForSelection) !== null && _h !== void 0 ? _h : "",
                    inputType: "textArea",
                    path: "justificationForSelection",
                    colSpan: 13,
                    rowSpan: 15,
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                }),
                // TODO:
                // globalUsersData[getApproval("officeManager")?.userId]?.jobTitle !==
                //   "officeManager" &&
                // state.status !== "pendingCBAOfficeManagerApproval" &&
                // state.status !== "draft" &&
                // state.status !== "cancelled"
                //   ? TitleCell({
                //       title:
                //         globalUsersData[getApproval("officeManager")?.userId]?.jobTitle,
                //       colSpan: 4,
                //       rowSpan: 3,
                //     })
                //   : TitleCell({
                //       title: t("cba.officeManager"),
                //       colSpan: 4,
                //       rowSpan: 3,
                //     }),
                (0, titleCell_1.TitleCell)({
                    title: t("cba.officeManager"),
                    colSpan: 4,
                    rowSpan: 3,
                }),
                (0, titleCell_1.TitleCell)({ title: t("cba.date"), colSpan: 3, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("cba.signName"), colSpan: 7, rowSpan: 1 }),
            ],
            [
                // ValueCell({
                //   value: approvingDate("officeManager"),
                //   colSpan: 3,
                //   rowSpan: 2,
                // }),
                (0, valueByMode_1.ValueByMode)({
                    mode: sigMode("officeManager"),
                    value: sigMode("officeManager") === "view"
                        ? approvingDate("officeManager")
                        : state.approvedAtSignatureDate,
                    inputType: "datePicker",
                    path: "approvedAtSignatureDate",
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                    colSpan: 3,
                    rowSpan: 2,
                }),
                (0, permissiontypes_1.permissionTypes)("showAllSignatures")
                    ? approvalCell("officeManager")
                    : (0, emptyCell_1.emptyCell)({}),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("officeManager"),
                    colSpan: 5,
                    rowSpan: 2,
                }),
            ],
            [],
            [
                // globalUsersData[getApproval("logistics")?.userId]?.jobTitle !==
                //   "logistics" &&
                // state.status !== "pendingCBALogisticsApproval" &&
                // state.status !== "pendingCBAOfficeManagerApproval" &&
                // state.status !== "draft" &&
                // state.status !== "cancelled"
                //   ? TitleCell({
                //       title:
                //         globalUsersData[getApproval("logistics")?.userId]?.jobTitle,
                //       colSpan: 4,
                //       rowSpan: 3,
                //     })
                //   : TitleCell({ title: t("cba.logistics"), colSpan: 4, rowSpan: 3 }),
                (0, titleCell_1.TitleCell)({ title: t("cba.logistics"), colSpan: 4, rowSpan: 3 }),
                (0, titleCell_1.TitleCell)({ title: t("cba.date"), colSpan: 3, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("cba.signName"), colSpan: 7, rowSpan: 1 }),
            ],
            [
                // ValueCell({
                //   value: approvingDate("logistics"),
                //   colSpan: 3,
                //   rowSpan: 2,
                // }),
                getApproval("officeManager")
                    ? (0, valueByMode_1.ValueByMode)({
                        mode: sigMode("logistics"),
                        value: sigMode("logistics") === "view"
                            ? approvingDate("logistics")
                            : state.approvedAtSignatureDate,
                        inputType: "datePicker",
                        path: "approvedAtSignatureDate",
                        required: state.triedSubmitting,
                        triedSubmitting: state.triedSubmitting,
                        colSpan: 3,
                        rowSpan: 2,
                    })
                    : (0, emptyCell_1.emptyCell)({ colSpan: 3, rowSpan: 2 }),
                (0, permissiontypes_1.permissionTypes)("showAllSignatures")
                    ? approvalCell("logistics", "officeManager")
                    : (0, emptyCell_1.emptyCell)({}),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("logistics"),
                    colSpan: 5,
                    rowSpan: 2,
                }),
            ],
            [],
            [
                // globalUsersData[getApproval("financeProjectsManager")?.userId]
                //   ?.jobTitle !== "financeProjectsManager" &&
                // state.status !== "pendingCBAFinanceProjectsManagerApproval" &&
                // state.status !== "pendingCBALogisticsApproval" &&
                // state.status !== "pendingCBAOfficeManagerApproval" &&
                // state.status !== "draft" &&
                // state.status !== "cancelled"
                //   ? TitleCell({
                //       title:
                //         globalUsersData[getApproval("financeProjectsManager")?.userId]
                //           ?.jobTitle,
                //       colSpan: 4,
                //       rowSpan: 3,
                //     })
                //   : TitleCell({
                //       title: t("cba.financeProjectsManager"),
                //       colSpan: 4,
                //       rowSpan: 3,
                //     }),
                (0, titleCell_1.TitleCell)({
                    title: t("cba.financeProjectsManager"),
                    colSpan: 4,
                    rowSpan: 3,
                }),
                (0, titleCell_1.TitleCell)({ title: t("cba.date"), colSpan: 3, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("cba.signName"), colSpan: 7, rowSpan: 1 }),
            ],
            [
                // ValueCell({
                //   value: approvingDate("financeProjectsManager"),
                //   colSpan: 3,
                //   rowSpan: 2,
                // }),
                getApproval("logistics")
                    ? (0, valueByMode_1.ValueByMode)({
                        mode: sigMode("financeProjectsManager"),
                        value: sigMode("financeProjectsManager") === "view"
                            ? approvingDate("financeProjectsManager")
                            : state.approvedAtSignatureDate,
                        inputType: "datePicker",
                        path: "approvedAtSignatureDate",
                        required: state.triedSubmitting,
                        triedSubmitting: state.triedSubmitting,
                        colSpan: 3,
                        rowSpan: 2,
                    })
                    : (0, emptyCell_1.emptyCell)({ colSpan: 3, rowSpan: 2 }),
                (0, permissiontypes_1.permissionTypes)("showAllSignatures")
                    ? approvalCell("financeProjectsManager", "logistics")
                    : (0, emptyCell_1.emptyCell)({}),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("financeProjectsManager"),
                    colSpan: 5,
                    rowSpan: 2,
                }),
            ],
            [],
            [
                // !getApproval("deputyGeneralDirector") && state.status === "approved"
                //   ? null
                //   : TitleCell({
                //       title: t("cba.deputyGeneralDirector"),
                //       colSpan: 4,
                //       rowSpan: 3,
                //     }),
                (0, titleCell_1.TitleCell)({
                    title: t("cba.deputyGeneralDirector"),
                    colSpan: 4,
                    rowSpan: 3,
                }),
                !getApproval("deputyGeneralDirector") && state.status === "approved"
                    ? null
                    : (0, titleCell_1.TitleCell)({ title: t("cba.date"), colSpan: 3, rowSpan: 1 }),
                !getApproval("deputyGeneralDirector") && state.status === "approved"
                    ? null
                    : (0, titleCell_1.TitleCell)({ title: t("cba.signName"), colSpan: 7, rowSpan: 1 }),
            ],
            [
                !getApproval("deputyGeneralDirector") && state.status === "approved"
                    ? null
                    : //   : ValueCell({
                        //       value: approvingDate("deputyGeneralDirector"),
                        //       colSpan: 3,
                        //       rowSpan: 2,
                        //     }),
                        getApproval("financeProjectsManager")
                            ? (0, valueByMode_1.ValueByMode)({
                                mode: sigMode("deputyGeneralDirector"),
                                value: sigMode("deputyGeneralDirector") === "view"
                                    ? approvingDate("deputyGeneralDirector")
                                    : state.approvedAtSignatureDate,
                                inputType: "datePicker",
                                path: "approvedAtSignatureDate",
                                required: state.triedSubmitting,
                                triedSubmitting: state.triedSubmitting,
                                colSpan: 3,
                                rowSpan: 2,
                            })
                            : (0, emptyCell_1.emptyCell)({ colSpan: 3, rowSpan: 2 }),
                !getApproval("deputyGeneralDirector") && state.status === "approved"
                    ? null
                    : (0, permissiontypes_1.permissionTypes)("showAllSignatures")
                        ? approvalCell("deputyGeneralDirector", "financeProjectsManager")
                        : (0, emptyCell_1.emptyCell)({}),
                ,
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("deputyGeneralDirector"),
                    colSpan: 5,
                    rowSpan: 2,
                }),
            ],
            [],
            [
                // !getApproval("generalDirector") && state.status === "approved"
                //   ? null
                //   : TitleCell({
                //       title: t("cba.generalDirector"),
                //       colSpan: 4,
                //       rowSpan: 3,
                //     }),
                (0, titleCell_1.TitleCell)({
                    title: t("cba.generalDirector"),
                    colSpan: 4,
                    rowSpan: 3,
                }),
                !getApproval("generalDirector") && state.status === "approved"
                    ? null
                    : (0, titleCell_1.TitleCell)({ title: t("cba.date"), colSpan: 3, rowSpan: 1 }),
                !getApproval("generalDirector") && state.status === "approved"
                    ? null
                    : (0, titleCell_1.TitleCell)({ title: t("cba.signName"), colSpan: 7, rowSpan: 1 }),
            ],
            [
                !getApproval("generalDirector") && state.status === "approved"
                    ? null
                    : //   : ValueCell({
                        //       value: approvingDate("generalDirector"),
                        //       colSpan: 3,
                        //       rowSpan: 2,
                        //     }),
                        getApproval("deputyGeneralDirector")
                            ? (0, valueByMode_1.ValueByMode)({
                                mode: sigMode("generalDirector"),
                                value: sigMode("generalDirector") === "view"
                                    ? approvingDate("generalDirector")
                                    : state.approvedAtSignatureDate,
                                inputType: "datePicker",
                                path: "approvedAtSignatureDate",
                                required: state.triedSubmitting,
                                triedSubmitting: state.triedSubmitting,
                                colSpan: 3,
                                rowSpan: 2,
                            })
                            : (0, emptyCell_1.emptyCell)({ colSpan: 3, rowSpan: 2 }),
                !getApproval("generalDirector") && state.status === "approved"
                    ? null
                    : (0, permissiontypes_1.permissionTypes)("showAllSignatures")
                        ? approvalCell("generalDirector", "deputyGeneralDirector")
                        : (0, emptyCell_1.emptyCell)({}),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("generalDirector"),
                    colSpan: 5,
                    rowSpan: 2,
                }),
            ],
        ];
    }
    var gridData = {
        data: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], CBAHeader, true), [
            itemsHeader
        ], false), itemsBody, true), bidDetails, true), itemsSummary, true), approvals(state, t), true), [
            [],
            [
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: "IMPORTANT: All actual and potential conflicts of interests must be disclosed to Independent Doctors Association directly to the employee’s supervisor or to Human Resources whenever a conflict arises. By signing this document Independent Doctors Association staff attests:- they or their immediate family members have no personal relationship with listed vendors or their employees, - no interest or financial gain or any other type of Conflict of Interest related to this procurement- to have not been employed by any of the vendors from solicitation previously.",
                    inputType: "text",
                    path: "ref",
                    colSpan: 28,
                    rowSpan: 4,
                }),
            ],
        ], false),
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(OrderHeader_1.default, { state: state, dispatch: dispatch, type: "CBA", orderRef: collectionsRef_1.CBAsRef.doc(CBAId) }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { backgroundColor: "#fff" } }, { children: (0, jsx_runtime_1.jsx)(Grid_1.ExcelLikeGrid, { onButtonClicked: function (action, payload) {
                        dispatch({
                            type: "buttonClick",
                            data: {
                                action: action,
                                payload: payload,
                            },
                        });
                    }, onValueUpdate: function (path, newValue) {
                        dispatch({
                            type: "update",
                            payload: {
                                path: path,
                                newValue: newValue,
                            },
                        });
                    }, grid: gridData }) }))] }));
};
exports.CBAGrid = CBAGrid;
exports.default = exports.CBAGrid;
